$(function(){

    if ($('body.news-blog').length) {
        const itemTemplate = ({
            url,
            title,
            subject
        }) => `
            <a href="${url}" data-aos="fade-up" class="news-blog-item col-span-12 md:col-span-6 lg:col-span-4 min-h-[30rem] lg:min-h-[40rem] px-[2.5rem] py-16 grid content-between bg-blue-dark">
                <div>
                    <span class="label">${subject}</span>                
                    <div class="text-white text-[3.2rem] leading-[38px] font-benton-semibold mb-8">${title}</div>
                </div>
                <span class="read-more">Read More&nbsp;+</span>
            </a>
        `;

        let doReplace = function(data) {
            let next = $('.next-page');

            $('.item-container').html(data.data.map(itemTemplate).join(''));
            $(next).data('page', data.meta.pagination.current_page);

            if (data.meta.pagination.total_pages === data.meta.pagination.current_page) {
                $(next).hide();
            } else if (data.meta.pagination.total_pages <= 1) {
                $(next).hide();
            } else {
                $(next).show();
            }

            if (data.meta.pagination.total == 0) {
                $('#noResults').show();
            } else {
                $('#noResults').hide();
            }     
        }

        $('.next-page').on('click', function(e) {
            e.preventDefault();
            let _this = this
            let currentPage = $(this).data('page');
            let attorney = $('#attorney-filter').find(":selected").val();
            let subject = $('#subject-filter').find(":selected").val();
            let params = [];
            let searchParams = new URLSearchParams(window.location.search);
            let type = $('.type-link.active').data('type') ? $('.type-link.active').data('type') : null;

            params.push('page=' + (currentPage+1));

            if (searchParams.has('subject')) {
                params.push('subject=' + searchParams.get('subject'));
            } else {
                params.push('subject=' + subject);
            }

            if (searchParams.has('attorney')) {
                params.push('attorney=' + searchParams.get('attorney'));
            } else {
                params.push('attorney=' + attorney);
            }

            if (type) {
                params.push('type=' + type);
            }

            $.getJSON( "/newsBlog.json?" + params.join('&'), function( data ) {

              $('.item-container').append(data.data.map(itemTemplate).join(''));
              $(_this).data('page', data.meta.pagination.current_page);
              
              if (data.meta.pagination.total_pages === data.meta.pagination.current_page) {
                $(_this).hide();
              }
            });
        });

        $('#subject-filter').on("change", function(e) {
            console.log('change');
            e.preventDefault();
            let attorney = $('#attorney-filter').find(":selected").val();
            let subject = $(this).find(":selected").val();
            let params = [];
            let searchParams = new URLSearchParams(window.location.search);
            let type = $('.type-link.active').data('type') ? $('.type-link.active').data('type') : null;

            params.push('subject=' + subject);

            if (searchParams.has('attorney')) {
                params.push('attorney=' + searchParams.get('attorney'));
            } else {
                params.push('attorney=' + attorney);
            }

             if (searchParams.has('page')) {
                params.push('page=' + searchParams.get('page'));
            }

            if (type) {
                params.push('type=' + type);
            }

            $.getJSON( "/newsBlog.json?" + params.join('&'), doReplace);

        });


        $('#attorney-filter').on("change", function(e) {

            e.preventDefault();
            let attorney = $(this).find(":selected").val();
            let subject = $('#subject-filter').find(":selected").val();
            let params = [];
            let searchParams = new URLSearchParams(window.location.search);
            let type = $('.type-link.active').data('type') ? $('.type-link.active').data('type') : null;

            params.push('attorney=' + attorney);

            if (searchParams.has('subject')) {
                params.push('subject=' + searchParams.get('subject'));
            } else {
                params.push('subject=' + subject);
            }

             if (searchParams.has('page')) {
                params.push('page=' + searchParams.get('page'));
            }

            if (type) {
                params.push('type=' + type);
            }

            $.getJSON( "/newsBlog.json?" + params.join('&'), doReplace);

        });

        $('.type-link').on('click', function(e) {
            e.preventDefault();

            let _this = this
            let attorney = $('#attorney-filter').find(":selected").val();
            let subject = $('#subject-filter').find(":selected").val();
            let params = [];
            let searchParams = new URLSearchParams(window.location.search);
            let type = $(this).data('type');

            if (type == "all") {
                $('.type-link').removeClass('active');
                $("#subject-filter option:selected").prop("selected", false);
                $("#attorney-filter option:selected").prop("selected", false);
            } else {
                if ($(_this).hasClass('active')) {
                    // Remove type
                    $('.type-link').removeClass('active');
                } else {
                    params.push('type=' + type);
                    $('.type-link').removeClass('active');
                    $(_this).addClass('active');
                }

                if (searchParams.has('subject')) {
                    params.push('subject=' + searchParams.get('subject'));
                } else {
                    params.push('subject=' + subject);
                }

                if (searchParams.has('attorney')) {
                    params.push('attorney=' + searchParams.get('attorney'));
                } else {
                    params.push('attorney=' + attorney);
                }
            }

            

            $.getJSON( "/newsBlog.json?" + params.join('&'), doReplace);
        });
    }
});